import { stringify } from 'query-string';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import { fetcher, fetchInfinite } from '@dashboard/services/request';

// react-query
async function getCustomerById(customerId, sellerId, token) {
  return fetcher(`/sellers/${sellerId}/customers/${customerId}`, token);
}

async function getCustomers(sellerId, query, token) {
  return fetcher(`/sellers/${sellerId}/customers?${stringify(query)}`, token);
}

// react-query
async function getInfiniteCustomers(sellerId, query, token) {
  return fetchInfinite(`/sellers/${sellerId}/customers?${stringify(query)}`, token);
}

// react-query
async function getCustomersByCheckout(checkoutId, sellerId, query, token) {
  return fetchInfinite(
    `/sellers/${sellerId}/pages/${checkoutId}/customers?${stringify(query)}`,
    token,
  );
}

export function useCustomerQueries() {
  const { token, sellerId } = useAuth();

  return {
    getCustomerById: customerId => getCustomerById(customerId, sellerId, token),
    getInfiniteCustomers: query => getInfiniteCustomers(sellerId, query, token),
    getCustomers: query => getCustomers(sellerId, query, token),
    getCustomersByCheckout: (checkoutId, query) =>
      getCustomersByCheckout(checkoutId, sellerId, query, token),
  };
}
